import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends Omit<HTMLMotionProps<'button'>, 'href'> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  icon: Icon,
  fullWidth = false,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-[#dc4a3d] text-white hover:bg-[#c0392b] focus:ring-[#dc4a3d] shadow-lg shadow-red-900/20',
    secondary: 'bg-[#1e3a5f] text-white hover:bg-[#162c4a] focus:ring-[#1e3a5f] shadow-lg shadow-blue-900/20',
    outline: 'border-2 border-[#1e3a5f] text-[#1e3a5f] hover:bg-[#1e3a5f]/5 focus:ring-[#1e3a5f]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.location.href = href;
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-175">
      {children}
      {Icon && <Icon className="ml-2 h-5 w-5" data-id="element-176" />}
    </motion.button>;
}